export default __webpack_public_path__ + "static/calendar_momo-da65305c19e0b449de83e997642b0e23.png";